import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import { preset } from '@@/lib/default/preset'
import '@/styles/main.scss'

Vue.use(Vuetify)

const options = {
}

export default new Vuetify({
  preset,
  ...options
})
